import { useMutation } from '@tanstack/react-query';
import { timeOffService } from '../api/time-off.service';
import type { CreateHistoricalTimeOffRequestPayload } from '../types';

/**
 * Registers a single past-dated request on behalf of another member.
 * Owner/Admin only. No cached query invalidation — this module exposes no
 * admin-facing read for historical requests (see the source doc's
 * "Known limitation").
 */
export function useCreateHistoricalTimeOffRequest() {
  return useMutation({
    mutationFn: (payload: CreateHistoricalTimeOffRequestPayload) =>
      timeOffService.createHistoricalRequest(payload),
  });
}
